import React, { useState, useEffect } from "react";
import { Html5QrcodeScanType, Html5Qrcode } from "html5-qrcode"
import { BasicFetch } from '../../../utils/BasicFetch.ts';
import { CollectionReptile } from '../types/CollectionTypes.ts';
import { ReptoolModal } from '../../utilities/ReptoolModal.tsx';
import { ReptileTile } from "../../utilities/ReptileTile.tsx";
const createReptileFromData = (data: CollectionReptile, updateGroups: () => void, closeModal: () => void) => {
  BasicFetch({
    url: `${(window as any).serverLocation}/collection_reptile/get/${data.uuid}/copy`,
    method: 'POST',
    onSuccess: () => {
      alert("Reptile added to collection");
      updateGroups();
      closeModal();
    },
    onFail: () => alert("Failed to create reptile"),
  })
}



const LoadFromServer = ({
  url,
  onSuccess,
  updateGroups,
  closeModal
}: {
  url: string,
  onSuccess?: (data: CollectionReptile) => void,
  updateGroups?: () => void,
  closeModal?: () => void
}) => {

  BasicFetch({
    url,
    extra: {
      data_only: 1
    },
    method: 'GET',
    onSuccess: (reptileData) => {
      if (onSuccess) {
        onSuccess(reptileData);
      }
      if (updateGroups && closeModal) {
        createReptileFromData(reptileData, updateGroups, closeModal)
      }
    },
    onFail: () => alert("Failed to get data"),
  });
}

export const QRCodeScannerModal = ({ closeModal, updateGroups }: { closeModal: Function, updateGroups: () => void }) => {
  const [scanning, setScanning] = useState(false);
  const [scannedText, setScannedText] = useState('');
  const [qrScanner, setQrScanner] = useState<Html5Qrcode | null>(null);
  const [currentReptile, setCurrentReptile] = useState<CollectionReptile | null>(null);
  const stopAndCloseModal = () => {
    if (scanning) {
      qrScanner?.stop();
    }
    closeModal();
  }
  const scannerConfig = {
    fps: 10,
    supportedScanTypes: [Html5QrcodeScanType.SCAN_TYPE_CAMERA],
    rememberLastUsedCamera: true,
    aspectRatio: 1.333334,
    qrbox: { width: 100, height: 100 },

  }

  const loadQrData = (data) => {
    LoadFromServer({ url: data, updateGroups, closeModal: stopAndCloseModal });
  }

  useEffect(() => {
    if (qrScanner == null) {
      return
    }
    if (scanning) {
      function onScanSuccess(decodedText, decodedResult) {
        // handle the scanned code as you like, for example:
        setScannedText(decodedText);
        LoadFromServer({ url: decodedText, onSuccess: (data) => { setCurrentReptile(data); setScanning(false) } })

      }

      function onScanFailure(error) {
        // handle scan failure, usually better to ignore and keep scanning.
        // for example:
        //console.warn(`Code scan error = ${error}`);
      }

      qrScanner.start({ facingMode: "environment" }, scannerConfig, onScanSuccess, onScanFailure);
    } else {
      qrScanner.stop();
    }

  }, [scanning]);
  useEffect(() => {
    setQrScanner(new Html5Qrcode("reader"));
    setScanning(true);
  }, [])
  return (
    <ReptoolModal
      id={"qrscanner-modal"}
      title={"Scan QR Code"}
      closeModal={stopAndCloseModal}
      body={(

        <div className="text-center">
          <div id="reader" width="600px"></div>
          {currentReptile && <div className="mt-3 d-flex justify-content-center">
            <ReptileTile reptile={currentReptile} hideButton={true} onSelected={() => { }} />
          </div>}

          {scannedText && <div className="mt-3 pb-4">
            <h6>Reptile successfully detected, what would you like to do?</h6>
            <div className="d-flex justify-content-center mt-4">
              <button
                className="button mx-2"
                onClick={() => { setScanning(true); setScannedText(''); setCurrentReptile(null); }}>
                Scan Again
              </button>
              <button
                className="button mx-2"
                onClick={() => { loadQrData(scannedText) }}
              >Add to Collection</button>
            </div>
          </div>}
        </div>
      )} />
  )
}